<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row class="no-gutters align-center">
      <v-col cols="12" sm="6" md="3" lg="6">
        <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search..." single-line
          solo hide-details></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="2" lg="3">
        <v-select solo :items="slots1" @input="sortByProfit" append-icon="mdi-chevron-down" label="Sort by profit(%)"
          class="custom-select"></v-select>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3">
        <ul>
          <li>
            <span class="">A Book Count</span>
            <span>{{ aBookData.length }}</span>
          </li>
          
          <li>
            <span class="">B Book Count:</span>
            <span>{{ pagination.total - aBookData.length }}</span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12">
        <v-card class="rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-data-table :headers="headers" :items="profitReachesFunc" :server-items-length="pagination?.total || 10"
              :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>

              <template v-slot:item.sl="{ index, item }">
                {{ index + 1 }}
              </template>

              <template v-slot:item.DateTime="{ item }">
                {{ item?.created_at }}
              </template>


              <template v-slot:item.nameLink="{ item }">
                <router-link class="text-capitalize text--ash"
                  :to="`/registered-user-details/${item?.client_account_id}`">
                  {{ `${item?.accounts?.fname} ${item?.accounts?.lname} (${item?.client_account_id})` }}
                </router-link>
              </template>

              <template v-slot:item.AccountNo="{ item }">
                {{ item.trading_account_no }}
              </template>

              <template v-slot:item.EmailView="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.accounts?.email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">{{
                        copiedStates[item.id]
                          ? "mdi mdi-check"
                          : "mdi-content-copy"
                      }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item?.accounts?.email }}</span>
                </v-tooltip>
              </template>

              <template v-slot:item.BalanceView="{ item }">
                {{ `$${parseFloat(item.balance).toFixed(2)}` }}
              </template>
              <template v-slot:item.EquityView="{ item }">
                {{ `$${parseFloat(item.equity).toFixed(2)}` }}
              </template>
              <template v-slot:item.ProfitView="{ item }">
                {{ `${item.allowed_profit_percent}%` }}
              </template>

            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { RMSSETTINGS__ACTIONS } from '@/store/action-types';
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";

export default {
  data() {
    return {
      search: "",
      searchTimeout: null,
      sortedData: [],
      aBookData:[],
      copiedStates: {},
      isLoading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      slots1: ["Profit Reach High-Low", "Profit Reach Low-High"],
      headers: [
        { text: "SL", align: "center", value: "sl" },
        { text: "Date & Time", value: "DateTime" },
        { text: "Name", value: "nameLink" },
        { text: "Account No.", value: "AccountNo" },
        { text: "Email", value: "EmailView" },
        { text: "Balance", value: "BalanceView" },
        { text: "Equity", value: "EquityView" },
        { text: "Profit(%)", value: "ProfitView" },
      ],
    };
  },
  computed: {
    ...mapState("rmssettings", [
      "profitReaches",
      "pagination",
      "summaries"
    ]),
    ...mapState("admins", ["loggedAdmin"]),
   
    profitReachesFunc() {
      return this.sortedData.length  ? this.sortedData  : this.aBookData;
    },
  },

  methods: {
    ...mapActions("rmssettings", [
      RMSSETTINGS__ACTIONS.PROFITREACHES,
      RMSSETTINGS__ACTIONS.UPDATEPROFITREACHES,

    ]),

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    aBookDataFunc() {
      this.fetchData();

      const data = this.$store.state.rmssettings.profitReaches;
      return data.filter(item => item.book_type !== 0);
    },

    async fetchData() {
      try {
        this.isLoading = true
        const params = {
          page: this.options.page || 1,
          limit: this.options.itemsPerPage || 10,
          search: this.search
        };

        await this[RMSSETTINGS__ACTIONS.PROFITREACHES](params);

        this.aBookData = this.aBookDataFunc();

      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },

    async handleSearch(value) {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    copyText(item) {
      navigator.clipboard.writeText(item.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },

    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },

    sortByProfit(selectedOption) {
      let sortedRows = [...this.aBookData];

      if (selectedOption === "Profit Reach High-Low") {
        sortedRows.sort((a, b) => 
          b.allowed_profit_percent - a.allowed_profit_percent
        );
      } else if (selectedOption === "Profit Reach Low-High") {
        sortedRows.sort((a, b) => 
          a.allowed_profit_percent - b.allowed_profit_percent
        );
      }
      // Update the local sorted rows
      this.sortedData = sortedRows;
    },

    handleOptionsChange(options) {
      this.fetchData();
    },
  },
  async created() {
    await this.fetchData();
    
  },
};
</script>
